// @flow
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import {
  FileUploadDiv,
  UploadIconImg,
  FileNameP,
  UploadLabelP,
  DropPanelDiv,
  FileUploadLabel,
  ThumbDiv,
  ThumbInnerDiv,
  PreviewImg,
  DeleteH5,
  SecondaryLabelSpan
} from './FileUploadStyles';
import { OutlineButton } from './ButtonStyles';
import { InputValidationSmall } from './InputStyles';
import uploadCloud from '../assets/images/upload-cloud.png';
import uploadedCloud from '../assets/images/uploaded-cloud.png';
import uploadCloudFailed from '../assets/images/upload-cloud-failed.png';
import { numberWithDelimiter } from '../utilities/numberFormatting';

type Props = {
  input: {
    value?: File,
    onChange: (value: ?File) => void
  },
  label: string,
  meta: {
    error?: string,
    touched?: boolean
  },
  currentUpload: ?string,
  hasPreview: ?boolean,
  hasIcon: ?boolean,
  acceptedFileTypes: string,
  maxSize: number,
  secondaryLabel?: string,
  fileUploadDirty: ?boolean,
  setFileUploadDirty: boolean => void
};
type State = {
  rejectedFile: ?File
};
export default class FileUpload extends Component<Props, State> {
  state = {
    rejectedFile: null
  };
  componentWillUnmount() {
    // $FlowFixMe
    URL.revokeObjectURL(this.props.input.value);
  }

  onDrop = (acceptedFiles: Array<File>, rejectedFile: Array<File>) => {
    this.props.setFileUploadDirty(true);
    this.props.input.onChange(acceptedFiles[0]);
    if (rejectedFile) {
      this.setState({ rejectedFile: rejectedFile[0] });
    }
  };

  removePreview = () => {
    this.props.input.onChange(null);
  };

  renderIcon = () => {
    let src = uploadCloud;
    if (
      (this.props.meta.error && this.props.meta.touched) ||
      this.state.rejectedFile
    ) {
      src = uploadCloudFailed;
    } else if (this.props.input.value) {
      src = uploadedCloud;
    }
    return <UploadIconImg src={src} />;
  };

  previewUrl = () => {
    if (this.props.input && this.props.input.value) {
      if (typeof this.props.input.value !== 'string') {
        return URL.createObjectURL(this.props.input.value);
      }
    }
    return this.props.input.value;
  };

  errorMessage = () => {
    if (this.props.meta.error) {
      return this.props.meta.error;
    } else if (
      this.state.rejectedFile &&
      this.state.rejectedFile.size > this.props.maxSize
    ) {
      return `File exceeds maximum upload size of ${numberWithDelimiter(
        this.props.maxSize / 1000
      )}KB`;
    } else {
      return 'Invalid file';
    }
  };

  render() {
    const { value } = this.props.input;
    let filename = 'Document uploaded';
    if (value && value !== true) {
      if (this.props.fileUploadDirty) {
        filename = value.name;
      } else if (typeof value === 'string') {
        const formattedFilenameArr = value.split('/');
        filename = formattedFilenameArr[formattedFilenameArr.length - 1];
      }
    }
    if (this.props.hasPreview && value) {
      return (
        <div>
          <ThumbDiv>
            <ThumbInnerDiv>
              <PreviewImg src={this.previewUrl()} />
              <DeleteH5 onClick={this.removePreview}>Delete</DeleteH5>
            </ThumbInnerDiv>
          </ThumbDiv>
        </div>
      );
    }
    return (
      <FileUploadDiv>
        <FileUploadLabel error={Boolean(this.props.meta.error)}>
          {this.props.label}
          <SecondaryLabelSpan> {this.props.secondaryLabel}</SecondaryLabelSpan>
        </FileUploadLabel>
        <Dropzone
          onDrop={this.onDrop}
          multiple={false}
          accept={this.props.acceptedFileTypes}
          maxSize={this.props.maxSize}
        >
          {({ getRootProps, getInputProps, isDragActive }) => (
            <DropPanelDiv
              {...getRootProps()}
              error={Boolean(this.props.meta.error)}
              dragActive={isDragActive}
            >
              {this.renderIcon()}
              {value ? (
                <FileNameP>{filename}</FileNameP>
              ) : (
                <UploadLabelP>Drag your files here or</UploadLabelP>
              )}
              <OutlineButton>{value ? 'Replace' : 'Upload'}</OutlineButton>
              <input {...getInputProps()} />
            </DropPanelDiv>
          )}
        </Dropzone>

        {(this.props.meta.error || this.state.rejectedFile) && (
          <InputValidationSmall
            meta={this.props.meta}
            rejected={this.state.rejectedFile}
          >
            {this.errorMessage()}
          </InputValidationSmall>
        )}
      </FileUploadDiv>
    );
  }
}
